import { useEffect } from 'react';

/** Calls `handler` on a pointer press outside every supplied ref, or on Escape. */
export default function useClickOutside(refs, handler, active = true) {
  useEffect(() => {
    if (!active) return undefined;
    const list = Array.isArray(refs) ? refs : [refs];

    const onPointer = (event) => {
      const inside = list.some((ref) => ref.current && ref.current.contains(event.target));
      if (!inside) handler(event);
    };
    const onKey = (event) => {
      if (event.key === 'Escape') handler(event);
    };

    document.addEventListener('mousedown', onPointer);
    document.addEventListener('touchstart', onPointer, { passive: true });
    document.addEventListener('keydown', onKey);
    return () => {
      document.removeEventListener('mousedown', onPointer);
      document.removeEventListener('touchstart', onPointer);
      document.removeEventListener('keydown', onKey);
    };
  }, [refs, handler, active]);
}
